import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AIAuditLogPluginState } from './types';

export const aiAuditLogsPluginKey = new PluginKey<AIAuditLogPluginState>('aiAuditLogs');
